import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const uploadToCloudinary = async (file, folder) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/cloudinary/upload?folder=${encodeURIComponent(folder)}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
};

export const MediaUpload = ({ folder, onUploaded, accept = "image/*", label = "Upload", testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try { onUploaded(await uploadToCloudinary(f, folder)); toast.success("Uploaded to Cloudinary"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); }
    setBusy(false);
  };
  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={pick} data-testid={testid ? `${testid}-file` : undefined} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border border-[#FECACA] text-sm text-[#7F1D1D] hover:bg-[#FEE2E2] disabled:opacity-50 shrink-0" data-testid={testid}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {label}
      </button>
    </>
  );
};
